/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: cdd2zPdEWaRL

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { MessagePartPopoverContentBlock } from "../../components/copilot/MessagePartPopoverContentBlock"; // plasmic-import: 1r7jyUeHxY8n/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicMessagePartPopoverContent.module.css"; // plasmic-import: cdd2zPdEWaRL/css

createPlasmicElementProxy;

export type PlasmicMessagePartPopoverContent__VariantMembers = {};
export type PlasmicMessagePartPopoverContent__VariantsArgs = {};
type VariantPropType = keyof PlasmicMessagePartPopoverContent__VariantsArgs;
export const PlasmicMessagePartPopoverContent__VariantProps =
  new Array<VariantPropType>();

export type PlasmicMessagePartPopoverContent__ArgsType = {
  title?: React.ReactNode;
};
type ArgPropType = keyof PlasmicMessagePartPopoverContent__ArgsType;
export const PlasmicMessagePartPopoverContent__ArgProps =
  new Array<ArgPropType>("title");

export type PlasmicMessagePartPopoverContent__OverridesType = {
  root?: Flex__<"div">;
  header?: Flex__<"div">;
  content?: Flex__<"div">;
};

export interface DefaultMessagePartPopoverContentProps {
  title?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicMessagePartPopoverContent__RenderFunc(props: {
  variants: PlasmicMessagePartPopoverContent__VariantsArgs;
  args: PlasmicMessagePartPopoverContent__ArgsType;
  overrides: PlasmicMessagePartPopoverContent__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames("all", sty.header)}
      >
        {renderPlasmicSlot({
          defaultContents: "Title",
          value: args.title,
          className: classNames(sty.slotTargetTitle),
        })}
      </div>
      <div
        data-plasmic-name={"content"}
        data-plasmic-override={overrides.content}
        className={classNames("all", sty.content)}
      >
        <MessagePartPopoverContentBlock
          className={classNames(
            "__wab_instance",
            sty.messagePartPopoverContentBlock__omXus
          )}
        />

        <MessagePartPopoverContentBlock
          className={classNames(
            "__wab_instance",
            sty.messagePartPopoverContentBlock__snGdG
          )}
          title={"Output"}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "header", "content"],
  header: ["header"],
  content: ["content"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: "div";
  content: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMessagePartPopoverContent__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMessagePartPopoverContent__VariantsArgs;
    args?: PlasmicMessagePartPopoverContent__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicMessagePartPopoverContent__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMessagePartPopoverContent__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMessagePartPopoverContent__ArgProps,
          internalVariantPropNames:
            PlasmicMessagePartPopoverContent__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicMessagePartPopoverContent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMessagePartPopoverContent";
  } else {
    func.displayName = `PlasmicMessagePartPopoverContent.${nodeName}`;
  }
  return func;
}

export const PlasmicMessagePartPopoverContent = Object.assign(
  // Top-level PlasmicMessagePartPopoverContent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    content: makeNodeComponent("content"),

    // Metadata about props expected for PlasmicMessagePartPopoverContent
    internalVariantProps: PlasmicMessagePartPopoverContent__VariantProps,
    internalArgProps: PlasmicMessagePartPopoverContent__ArgProps,
  }
);

export default PlasmicMessagePartPopoverContent;
/* prettier-ignore-end */
